(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('CustomersListController', CustomersListController);

    var CUSTOMER_ORIGIN = {
        MESSENGER: 'MESSENGER',
        INSTAGRAM: 'INSTAGRAM',
        WHATSAPP: 'WHATSAPP',
        INTEGRATION_API: 'INTEGRATION_API',
        FACEBOOK: 'FACEBOOK',
        GOOGLE: 'GOOGLE',
        TIKTOK: 'TIKTOK',
        WEBSITE: 'WEBSITE'
    };
    var CUSTOMER_ORIGINS = Object.keys(CUSTOMER_ORIGIN);

    /** @ngInject */
    function CustomersListController(CustomerService, $uibModal, CustomerModalFactory, toastr, $translate, MODAL_CONTENT_TYPES, $scope, $document, $timeout, $localStorage) {

        var vm = this;
        var userId = $localStorage.userId;
        var storeId = $localStorage.defaultStore && $localStorage.defaultStore.storeId;
        var filterLocalStorageKey = 'customer_filter_' + userId + '_' + storeId;

        vm.filter = {};
        vm.customers = [];

        vm.originalOrder = [];

        vm.currentPage = 1;
        vm.numPerPage = 10;
        vm.maxSize = 5;
        vm.totalCustomers = 0;

        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage,
            sort: null
        };

        var persistedFilters = $localStorage[filterLocalStorageKey] || {};
        vm.origin = CUSTOMER_ORIGIN;
        vm.tagSelection = persistedFilters.tagSelection || getSelectAllPaginatedModel();
        console.log("persistedFilters.originSelection", persistedFilters.originSelection)
        vm.originSelection = migrateLegacyOriginSelection(persistedFilters.originSelection || []);
        vm.filter.tagTexts = collectSelectedValues(vm.tagSelection);
        vm.filter.origins = collectOriginValues(vm.originSelection);
        vm.originOptions = CUSTOMER_ORIGINS.map(function (value) {
            return {
                id: value,
                value: value,
                label: $translate.instant('customer.origin.' + value)
            };
        });

        vm.createdThroughIcons = {
            WHATSAPP: 'content/images/icon-whatsapp-connection.png',
            INSTAGRAM: 'content/images/icon-instagram.png',
            MESSENGER: 'content/images/icon-messenger.png'
        };

        vm.createdThroughLinks = {
            INSTAGRAM: function (customer) {
                return 'https://www.instagram.com/' + customer.facebookInstagramProfile + '/';
            },
            WHATSAPP: function (customer) {
                return 'https://wa.me/' + customer.phone;
            },
            MESSENGER: function (customer) {
                return 'https://m.me/' + customer.facebookInstagramId;
            }
        };

        vm.dateFormat = $translate.instant('momentDateFormat');

        vm.orderedByBirthdayWeek = false;
        vm.searchByFilter = searchByFilter;
        vm.filterChange = filterChange;
        vm.listTagFilterOptions = listTagFilterOptions;
        vm.applyFilters = applyFilters;
        vm.hasActiveFilters = hasActiveFilters;
        vm.clearFilters = clearFilters;

        init();

        function init() {
            listCustomers(vm.paginationOptions, vm.filter);
        }

        vm.orderByBirthdayWeek = function () {
            vm.orderedByBirthdayWeek = !vm.orderedByBirthdayWeek;

            vm.filter.orderedByBirthdayWeek = vm.orderedByBirthdayWeek;
            resetPagination();
            listCustomers(vm.paginationOptions, vm.filter);

        }

        function parseDates(elements){
            elements.forEach(function (element){
                element.birthdate = element.birthdate ? moment.utc(element.birthdate) : null;
            });
        }

        function listCustomers(pagination, filter) {
            vm.loadingCustomers = true;
            CustomerService.list(pagination, filter).then(function (result) {
                vm.loadingCustomers = false;
                if (!result.data){
                    return;
                }

                parseDates(result.data);
                vm.totalCustomers = result.headers['x-total-count'];
                vm.endRegistry = Math.min(vm.endRegistry, parseInt(vm.totalCustomers, 10));
                vm.customers = result.data.slice();

                $timeout(function () {
                    vm.customers.forEach(function (customer) {
                        updateScrollArrows(
                            'tagsBox-' + customer.id,
                            'showLeftArrow',
                            'showRightArrow',
                            customer
                        );
                    });
                });
            });
        }

        vm.selectCustomer = function (customer) {
            openSideMenu(customer);
        }

        vm.createCustomer = function () {
            openSideMenu({});
        }

        vm.showModalDeleteCustomer = function (customer) {
            CustomerModalFactory.deleteCustomer(customer).then(function (result) {
                if (result) {
                    CustomerService.delete(customer.id).then(function (result) {
                        toastr.success($translate.instant(result.headers["x-adminapp-alert"]));
                        listCustomers(vm.paginationOptions, vm.filter);
                    });
                }
            });
        }

        function openSideMenu(customer) {
            return $uibModal.open({
                templateUrl: 'app/components/modal/side-modal/side-modal.html',
                controller: 'SideModalController',
                windowClass: 'side-modal',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    content: function () {
                        return {
                            title: !customer.id ? $translate.instant('global.form.createCustomer') : '',
                            cancelButtonText: !customer.id ? $translate.instant('global.messages.remove.cancel'): '',
                            confirmButtonText: !customer.id ? $translate.instant('communication.create'): '',
                            customer: customer,
                            type: MODAL_CONTENT_TYPES.CUSTOMER
                        }
                    }
                }
            }).result.then(function () {
                listCustomers(vm.paginationOptions, vm.filter);
            });
        }

        function searchByFilter() {
            if (vm.filter.fullName) {
                resetPagination();
                listCustomers(vm.paginationOptions, vm.filter);
            }
        }

        function filterChange() {
            resetPagination();
            listCustomers(vm.paginationOptions, vm.filter);
        }

        function listTagFilterOptions(pageable, search, onSuccess, onError) {
            return CustomerService.listFilterTags(pageable, search, onSuccess, onError);
        }

        function applyFilters() {
            vm.filter.tagTexts = collectSelectedValues(vm.tagSelection);
            vm.filter.tagAll = isSelectAllActive(vm.tagSelection);
            vm.filter.origins = collectOriginValues(vm.originSelection);

            persistFilters();
            resetPagination();
            listCustomers(vm.paginationOptions, vm.filter);
        }

        function collectSelectedValues(model) {
            if (!model || !model.only || !model.only.length) {
                return null;
            }
            return model.only.slice();
        }

        function isSelectAllActive(model) {
            return !!(model && model.all && (!model.except || !model.except.length));
        }

        function resetPagination() {
            vm.currentPage = 1;
            vm.paginationOptions.page = 0;
            vm.startRegistry = 1;
            vm.endRegistry = vm.numPerPage;
        }

        function collectOriginValues(selection) {
            if (!selection || !selection.length) {
                return null;
            }
            return selection.map(function (item) { return item.value; });
        }

        function migrateLegacyOriginSelection(selection) {
            if (!selection || !selection.length) {
                return selection || [];
            }
            return selection.map(function (item) {
                if (!item) {
                    return item;
                }
                if (item.value === 'WATI' || item.id === 'WATI') {
                    return {
                        id: CUSTOMER_ORIGIN.WHATSAPP,
                        value: CUSTOMER_ORIGIN.WHATSAPP,
                        label: $translate.instant('customer.origin.WHATSAPP')
                    };
                }
                return item;
            });
        }

        function persistFilters() {
            $localStorage[filterLocalStorageKey] = {
                tagSelection: angular.copy(vm.tagSelection),
                originSelection: angular.copy(vm.originSelection)
            };
        }

        function hasActiveFilters() {
            var hasText = !!(vm.filter.fullName && vm.filter.fullName.trim());
            var hasTags = !!(vm.filter.tagTexts && vm.filter.tagTexts.length);
            var hasOrigins = !!(vm.filter.origins && vm.filter.origins.length);
            return hasText || hasTags || hasOrigins;
        }

        function clearFilters() {
            vm.filter = { tagAll: false };
            vm.tagSelection = getSelectAllPaginatedModel();
            vm.originSelection = [];
            delete $localStorage[filterLocalStorageKey];
            resetPagination();
            listCustomers(vm.paginationOptions, vm.filter);
        }

        vm.changePage = function () {

            var begin = ((vm.currentPage - 1) * vm.numPerPage),
                end = begin + vm.numPerPage;

            vm.paginationOptions.page = vm.currentPage - 1;

            listCustomers(vm.paginationOptions, vm.filter);
            vm.startRegistry = begin + 1;
            vm.endRegistry = end;

        }

        vm.scrollBox = function (boxId, direction, leftArrowKey, rightArrowKey, $event, customer) {
            if ($event) {
                $event.stopPropagation();
            }

            var boxCompleteId = boxId + "-" + customer.id;
            var box = $document[0].getElementById(boxCompleteId);
            var scrollAmount = 150;
            if (!box){
                return;
            }

            box.scrollLeft += direction === 'left' ? -scrollAmount : scrollAmount;

            updateScrollArrows(boxCompleteId, leftArrowKey, rightArrowKey, customer);
        };

        function updateScrollArrows(boxId, leftArrowKey, rightArrowKey, customer) {
            var box = $document[0].getElementById(boxId);
            if (!box) {
                return;
            }

            customer[leftArrowKey] = box.scrollLeft > 0;

            customer[rightArrowKey] =
                box.scrollLeft + box.clientWidth < box.scrollWidth;

            $scope.$applyAsync();
        }
    }
})();
